var _defs, _path, _use, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedditLogo2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 774 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-9 {\n        fill: #842123;\n      }\n\n      .cls-10 {\n        fill: #bbcfda;\n      }\n\n      .cls-11 {\n        fill: #ff6101;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: #ff4500;\n      }\n\n      .cls-14 {\n        fill: #ffc49c;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 370.49,
    cy: 151.59,
    fx: 370.49,
    fy: 142.47,
    r: 127.45,
    gradientTransform: "translate(0 19.13) scale(1 .87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f9fcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#edf3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#dee9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d8e4e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ccd8df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c8d5dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ccd6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d8dbe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#ede3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffebef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 64.38,
    fx: 64.38,
    fy: 142.47,
    r: 127.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 220.14,
    cy: 135.08,
    fx: 220.14,
    fy: 135.08,
    r: 384.44,
    gradientTransform: "translate(0 40.35) scale(1 .7)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 134.7,
    cy: 240.48,
    fx: 134.7,
    fy: 240.48,
    r: 32.12,
    gradientTransform: "translate(0 -110.04) scale(1 1.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fc4301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f43f07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#e53812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4301f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 6191.5,
    cy: 240.48,
    fx: 6191.5,
    fy: 240.48,
    r: 32.12,
    gradientTransform: "translate(6489.32 -110.04) rotate(-180) scale(1 -1.46)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 215.93,
    cy: 338.52,
    fx: 215.93,
    fy: 338.52,
    r: 113.26,
    gradientTransform: "translate(0 116.39) scale(1 .66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0e1c21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#030708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 315.81,
    cy: 3.47,
    fx: 315.81,
    fy: 3.47,
    r: 99.42,
    gradientTransform: "translate(0 .06) scale(1 .98)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 274.38,
    cy: 103.82,
    fx: 274.38,
    fy: 103.82,
    r: 81.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7a9299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#172e35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#172e35"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Snoo",
    viewBox: "0 0 432.21 377.72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 369.16,
    cy: 188.55,
    r: 63.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.05,
    cy: 188.55,
    r: 63.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 216.26,
    cy: 242.72,
    rx: 180,
    ry: 135
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m163.04,229.59c-1.05,22.87-16.23,31.17-33.91,31.17s-31.15-11.71-30.09-34.58c1.05-22.87,16.23-38.01,33.91-38.01s31.15,18.54,30.09,41.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m333.48,226.18c1.05,22.87-12.42,34.58-30.09,34.58s-32.85-8.3-33.91-31.17c-1.05-22.87,12.42-41.42,30.09-41.42s32.85,15.13,33.91,38.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.05,231.59c-.99,21.41-15.19,29.17-31.73,29.17s-29.15-11.63-28.16-33.03c.99-21.41,15.19-35.41,31.73-35.41s29.15,17.86,28.16,39.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m269.47,231.59c.99,21.41,15.19,29.17,31.73,29.17,16.54,0,29.15-11.63,28.16-33.03-.99-21.41-15.19-35.41-31.73-35.41s-29.15,17.86-28.16,39.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 145.19,
    cy: 212.04,
    rx: 7,
    ry: 7.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 311.64,
    cy: 212.04,
    rx: 7,
    ry: 7.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.26,276.02c-22.32,0-43.71,1.08-63.49,3.04-3.38.34-5.52,3.78-4.21,6.86,11.08,25.97,37.22,44.21,67.7,44.21s56.62-18.24,67.7-44.21c1.31-3.08-.83-6.52-4.21-6.86-19.78-1.97-41.17-3.04-63.49-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m216.26,280.98c-22.25,0-43.57,1.09-63.29,3.09-3.37.34-5.51,3.84-4.2,6.97,11.05,26.38,37.1,44.91,67.49,44.91s56.44-18.53,67.49-44.91c1.31-3.12-.83-6.62-4.2-6.97-19.72-2-41.04-3.09-63.29-3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m216.26,278.4c-21.9,0-42.89,1.08-62.3,3.04-3.32.34-5.42,3.78-4.13,6.86,10.87,25.97,36.52,44.21,66.44,44.21s55.56-18.24,66.44-44.21c1.29-3.08-.81-6.52-4.13-6.86-19.41-1.97-40.4-3.04-62.31-3.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 314.84,
    cy: 44.68,
    r: 44.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m215.62,113.41c-5.35,0-9.69-2.24-9.69-5.69,0-40.03,32.56-72.59,72.59-72.59,5.35,0,9.69,4.34,9.69,9.69s-4.34,9.69-9.69,9.69c-29.34,0-53.22,23.87-53.22,53.22,0,3.45-4.34,5.69-9.69,5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m151.29,242.18c0,8.28-8.81,12-19.69,12s-19.69-3.72-19.69-12,8.81-15,19.69-15,19.69,6.72,19.69,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m320.6,242.18c0,8.28-8.81,12-19.69,12s-19.69-3.72-19.69-12,8.81-15,19.69-15,19.69,6.72,19.69,15Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m108,0h0C48.35,0,0,48.35,0,108h0c0,29.82,12.09,56.82,31.63,76.37l-20.57,20.57c-4.08,4.08-1.19,11.06,4.58,11.06h92.36s0,0,0,0c59.65,0,108-48.35,108-108h0C216,48.35,167.65,0,108,0Z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 432.21,
    height: 377.72,
    transform: "translate(21.56 31.55) scale(.4)",
    xlinkHref: "#Snoo"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m331.62,77.92l-12.01,28.56c-1.51-.76-5.11-1.61-8.51-1.61s-6.81.85-10.12,2.46c-6.53,3.31-11.35,9.93-11.35,19.48v52.3h-29.89v-101.77h29.04v14.28h.57c6.81-9.08,17.21-15.79,30.74-15.79,4.92,0,9.65.95,11.54,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m325.84,128.52c0-29.41,20.15-52.68,50.32-52.68,27.33,0,46.91,19.96,46.91,48.05,0,4.92-.47,9.55-1.51,14h-68.48c3.12,10.69,12.39,19.01,26.29,19.01,7.66,0,18.54-2.74,24.4-7.28l9.27,22.32c-8.61,5.86-21.75,8.7-33.29,8.7-32.25,0-53.91-20.81-53.91-52.11Zm26.67-9.36h43.03c0-13.05-8.89-19.96-19.77-19.96-12.3,0-20.62,7.94-23.27,19.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m679.53,31.63c10.03,0,18.25,8.23,18.25,18.25s-8.23,18.25-18.25,18.25-18.25-8.23-18.25-18.25,8.23-18.25,18.25-18.25Zm14.94,147.49h-29.89v-101.77h29.89v101.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m506,33.47l-.09,53.53h-.57c-8.23-7.85-17.12-11.07-28.75-11.07-28.66,0-47.67,23.08-47.67,52.3s17.78,52.4,46.72,52.4c12.11,0,23.55-4.16,30.93-13.62h.85v12.11h28.47V33.47h-29.89Zm1.42,121.39h-.99l-6.67-6.93c-4.34,4.33-10.28,6.93-17.22,6.93-14.64,0-24.88-11.58-24.88-26.6s10.24-26.6,24.88-26.6,24.88,11.58,24.88,26.6v26.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m620.15,33.47l-.09,53.53h-.57c-8.23-7.85-17.12-11.07-28.75-11.07-28.66,0-47.67,23.08-47.67,52.3s17.78,52.4,46.72,52.4c12.11,0,23.55-4.16,30.93-13.62h.85v12.11h28.47V33.47h-29.89Zm1.28,121.39h-.99l-6.67-6.93c-4.34,4.33-10.28,6.93-17.22,6.93-14.64,0-24.88-11.58-24.88-26.6s10.24-26.6,24.88-26.6,24.88,11.58,24.88,26.6v26.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m752.44,77.35h21.85v25.44h-21.85v76.33h-29.89v-76.33h-21.75v-25.44h21.75v-27.66h29.89v27.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedditLogo2023);
export default __webpack_public_path__ + "static/media/Reddit_logo_2023.4d0882ae5661728a9a594f2571efcfc3.svg";
export { ForwardRef as ReactComponent };